import { useState } from 'react';
import {BiSave} from 'react-icons/bi';
import { baseURL } from '../../config/config';
import axios from 'axios';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import TablaMcleod from './TablaMcleod';

import { IoIosAddCircle } from "react-icons/io";
import { MdDeleteForever } from "react-icons/md";

import Tabla from '../../components/Tabla';

const ModalCrearOrdenLogistica = (props) => {

    // ===============================================
    // SEGMENTO PARA SUBMIT CREAR ORDEN
    // ===============================================

    const urlCreate = baseURL + "api/create/orden/logistica";

    const handleSubmit = (event) => {

        event.preventDefault();

        console.log(props.data)

        const token = Cookies.get('jwtoken');

        let validar = true;

        Object.entries(props.data).forEach(entry => {

            const [key,value] = entry;
    
            if(value === "" || value === null){

                if(
                    props.data.cruce_impo_expo === '' || 
                    props.data.cruce_impo_expo === 'N/A' || 
                    props.data.cruce_impo_expo === null &&
                    key === 'cruce_impo_expo' ||
                    key === 'cruce_monto' ||
                    key === 'cruce_origen' ||
                    key === 'cruce_destino' ||
                    key === 'tipo_cambio'
                ){

                    console.log('ok')

                }else{

                    if(key !== 'orden_mcleod'){

                        Swal.fire({
                            icon: 'warning',
                            title: 'No pueden ir campos vacios!',
                        })
        
                        validar = false;
            
                        return;
    
                    }

                }

                
    
            }
    
        });

        if(validar){

            axios.post(urlCreate, props.data,{
  
                headers: {
                    "access-token": token
                } 
        
            })
            .then(result => {

                console.log(result)
        
                if(result.data.success === true)
                {
            
                    Swal.fire({
                        icon: 'success',
                        title: 'Se ha creado correctamente!',
                    }).then(() => {
            
                        props.refresh();
                        document.getElementById("btnCerrarModalCrearOrdenL").click();
                        limpiarModal();
            
                    })
            
                }
        
            })
            .catch(error => {
        
                console.log(error)
        
            })

        }

    };

    // ===============================================
    // FUNCION PARA LIMPIAR MODAL
    // ===============================================

    const limpiarModal = () => {

        document.getElementById("impoExpoOrden").value = "";
        document.getElementById("clienteOrdenL").value = "";
        document.getElementById("rutaOrdenL").value = "";
        document.getElementById("referenciaOrdenG").value = "";
        document.getElementById("cajaOrdenL").value = "";
        document.getElementById("pesoOrdenL").value = "";
        document.getElementById("temp1OrdenL").value = "";
        document.getElementById("temp2OrdenL").value = "";
        document.getElementById("comodityOrdenL").value = "";
        document.getElementById("palletsOrdenL").value = "";
        document.getElementById("fechaROrdenL").value = "";
        document.getElementById("horaROrdenL").value = "";
        document.getElementById("fechaEOrdenL").value = "";
        document.getElementById("horaEOrdenL").value = "";
        document.getElementById("casesOrdenL").value = "";
        document.getElementById("proveedorOrdenL").value = "";
        document.getElementById("monedaOrdenL").value = "";
        document.getElementById("tarifaOrdenL").value = "";
        document.getElementById("bolOrdenL").value = "";
        document.getElementById("facturaOrdenL").value = "";
        document.getElementById("orden_mcleodL").value = "";

        //document.getElementById("cruce_impo_expoSelectL").value = "";
        //document.getElementById("cruce_montoInputL").value = "";
        //document.getElementById("cruce_origenInputL").value = "";
        //document.getElementById("cruce_destinoInputL").value = "";
        document.getElementById("tipo_cambioInputL").value = "";
        document.getElementById("tarifa_proveedorL").value = "";
        document.getElementById("monedaProveedorOrdenL").value = "";

    }

    // ===============================================
    // SECCION PARA INGRESOS
    // ===============================================

    const [ingreso, setIngreso] = useState({
    
        concepto: "",
        monto: "",
        moneda: ""

    });

    const columnsIngresos = [
    
        {
            name: 'Concepto',
            selector: row => row.concepto,
            sortable: true,
            width: '45%',
        },
        {
            name: 'Monto',
            selector: row => `$ ${row.monto}`,
            sortable: true,
            width: '20%',
        },
        {
            name: 'Moneda',
            selector: row => row.moneda,
            sortable: true,
            width: '20%',
        },
        {
            name: '',
            sortable: true,
            width: '15%',
            cell: (row) =>

                <button 
                    className="btn btn-outline-danger" 
                    type="button"  
                    onClick={() => props.deleteIngreso(row.concepto, row.monto, row.moneda)}
                >
                    <MdDeleteForever/>
                </button>
        },

    ];

    // ===============================================
    // SECCION PARA EGRESOS
    // ===============================================

    const [egreso, setEgreso] = useState({
    
        concepto: "",
        monto: "",
        moneda: ""

    });

    const columnsEgresos = [
    
        {
            name: 'Concepto',
            selector: row => row.concepto,
            sortable: true,
            width: '45%',
        },
        {
            name: 'Monto',
            selector: row => `$ ${row.monto}`,
            sortable: true,
            width: '20%',
        },
        {
            name: 'Moneda',
            selector: row => row.moneda,
            sortable: true,
            width: '20%',
        },
        {
            name: '',
            sortable: true,
            width: '15%',
            cell: (row) =>

                <button 
                    className="btn btn-outline-danger" 
                    type="button"  
                    onClick={() => props.deleteEgreso(row.concepto, row.monto, row.moneda)}
                >
                    <MdDeleteForever/>
                </button>
        },

    ];

    return (

        <div>

            <div className="modal fade" id="modalCrearOrdenLogistica"  aria-hidden="true" data-bs-backdrop="static">

                <div className="modal-dialog modal-xl">

                    <div className="modal-content">

                        <form onSubmit={handleSubmit}>

                            <div className="modal-header">

                                <h5 className="modal-title" id="exampleModalLabel">Crear Orden</h5>

                                <button type="button" className="btn-close" id="btnCerrarModalCrearOrdenL" data-bs-dismiss="modal" aria-label="Close"></button>

                            </div>

                            <div className="modal-body">

                                <div className='row'>

                                    {/* SECCION DEL FORMULARIO */}

                                    <div className='col-12'>

                                        <div class="accordion" id="accordionOrdenesLogistica">

                                            {/* DATOS DE LA ORDEN */}

                                            <div class="accordion-item">

                                                <h2 class="accordion-header" id="headingOne">

                                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    Datos de la orden
                                                </button>

                                                </h2>
                                                
                                                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionOrdenesLogistica">

                                                    <div class="accordion-body">
                                                        
                                                        <div className='row'>

                                                            {/* SIMPORTACION / EXPORTACION */}

                                                            <div className='col-4'>

                                                            <span className="badge text-bg-secondary mb-2">Importacion / Exportacion:</span>

                                                            <select
                                                                key="subida_bajadaOrden"
                                                                name="impo_expo"
                                                                className="form-select"
                                                                id="impoExpoOrden"
                                                                onChange={props.onChange}>

                                                                <option value="">Seleccione una opcion</option>
                                                                <option value="Exportacion">Exportacion</option>
                                                                <option value="Importacion">Importacion</option>
                                                                
                                                            </select>

                                                            </div>

                                                            {/* CLIENTE */}

                                                            <div className='col-4'>

                                                            <span className="badge text-bg-secondary mb-2">Cliente:</span>

                                                            <select
                                                                name="rel_cliente"
                                                                className="form-select"
                                                                id="clienteOrdenL"
                                                                onChange={props.onChange}>

                                                                {props.clientes.map((op) => (
                                                                    <option key={op.id} value={op.id}>{op.nombre_comercial}</option>
                                                                ))}
                                                                
                                                            </select>

                                                            </div>

                                                            {/* RUTA DE ORDEN */}

                                                            <div className='col-4'>

                                                            <span className="badge text-bg-secondary mb-2">Ruta:</span>

                                                            <select
                                                                key="rutaOrden"
                                                                name="rel_ruta"
                                                                className="form-select"
                                                                id="rutaOrdenL"
                                                                onChange={props.onChange}>

                                                                {props.rutas.map((op) => (
                                                                    <option key={op.id} value={op.id}>{op.ruta_final}</option>
                                                                ))}
                                                                
                                                            </select>

                                                            </div>

                                                            {/* PROVEEDOR */}

                                                            <div className='col-4 mt-4'>

                                                            <span className="badge text-bg-secondary mb-2">Proveedor:</span>

                                                            <select
                                                                key="rutaOrden"
                                                                name="rel_proveedor"
                                                                className="form-select"
                                                                id="proveedorOrdenL"
                                                                onChange={props.onChange}>

                                                                {props.proveedores.map((op) => (
                                                                    <option key={op.id} value={op.id}>{op.nombre_comercial}</option>
                                                                ))}
                                                                
                                                            </select>

                                                            </div>

                                                            {/* REFERENCIA */}

                                                            <div className='col-4 mt-4'>

                                                            <span className="badge text-bg-secondary mb-2">Num. Referencia:</span>

                                                            <input
                                                                className='form-control'
                                                                key="numReferenciaOrden"
                                                                type="text"
                                                                id="referenciaOrdenG"
                                                                name="referencia"
                                                                placeholder="Ingrese numero de referencia"
                                                                autoComplete = "off"
                                                                onChange={props.onChange}
                                                                onBlur={props.validarCampos}
                                                            />

                                                            </div>

                                                            {/* CAJA */}

                                                            <div className='col-4 mt-4'>

                                                            <span className="badge text-bg-secondary mb-2">Caja:</span>

                                                            <select
                                                                key="clienteOrden"
                                                                name="rel_caja"
                                                                className="form-select"
                                                                id="cajaOrdenL"
                                                                onChange={props.onChange}>

                                                                {props.cajas.map((op) => (
                                                                    <option key={op.id} value={op.id}>{op.numero}</option>
                                                                ))}
                                                                
                                                            </select>

                                                            </div>

                                                            {/* TEMPERATURA 1 */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Temperatura Minima:</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="temp1Orden"
                                                                    type="number"
                                                                    id="temp1OrdenL"
                                                                    name="temperatura_1"
                                                                    placeholder="Ingrese temperatura en °F"
                                                                    autoComplete = "off"
                                                                    step=".01"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* FECHA RECOLECCION */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Fecha Recoleccion:</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="fechaRecoleccionOrden"
                                                                    type="date"
                                                                    id="fechaROrdenL"
                                                                    name="fecha_recoleccion"
                                                                    // onKeyDown={props.preventDates}
                                                                    placeholder="Ingrese fecha"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* FECHA ENTREGA */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Fecha Entrega:</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="fechaEntregaOrden"
                                                                    type="date"
                                                                    // onKeyDown={props.preventDates}
                                                                    id="fechaEOrdenL"
                                                                    name="fecha_entrega"
                                                                    placeholder="Ingrese fecha"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* TEMPERATURA 2 */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Temperatura Maxima:</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="temp2Orden"
                                                                    type="number"
                                                                    id="temp2OrdenL"
                                                                    name="temperatura_2"
                                                                    placeholder="Ingrese temperatura en °F"
                                                                    autoComplete = "off"
                                                                    step=".01"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* HORA RECOLECCION */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Hora Recoleccion:</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="horaRecoleccionOrden"
                                                                    type="time"
                                                                    name="hora_recoleccion"
                                                                    id="horaROrdenL"
                                                                    placeholder="Ingrese hora"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* HORA ENTREGA */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Hora Entrega:</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="horaEntregaOrden"
                                                                    type="time"
                                                                    id="horaEOrdenL"
                                                                    name="hora_entrega"
                                                                    placeholder="Ingrese hora"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* PESO */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Peso (k):</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="pesoOrden"
                                                                    type="number"
                                                                    name="peso"
                                                                    id="pesoOrdenL"
                                                                    placeholder="Ingrese peso en Kilogramos"
                                                                    autoComplete = "off"
                                                                    step=".01"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* COMMODITY */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Commodity:</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="commodityOrden"
                                                                    type="text"
                                                                    id="comodityOrdenL"
                                                                    name="commodity"
                                                                    placeholder="Ingrese commodity"
                                                                    autoComplete = "off"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* FACTURA MICROZIP */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Factura MicroZip:</span>

                                                                <input
                                                                    className='form-control'
                                                                    type="text"
                                                                    id="facturaOrdenL"
                                                                    name="factura_microsip"
                                                                    placeholder="Ingrese Factura"
                                                                    autoComplete = "off"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* REFACTURA */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Refactura:</span>

                                                                <input
                                                                    className='form-control'
                                                                    type="text"
                                                                    id="refacturaOrdenL"
                                                                    name="refactura"
                                                                    placeholder="Ingrese Refactura"
                                                                    autoComplete = "off"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* BOL */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">BOL:</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="bolOrden"
                                                                    type="text"
                                                                    id="bolOrdenL"
                                                                    name="bol"
                                                                    placeholder="Ingrese BOL"
                                                                    autoComplete = "off"
                                                                    onChange={props.onChange}
                                                                    onBlur={props.validarCampos}
                                                                />

                                                            </div>

                                                            {/* CASES */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Cases:</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="casesOrden"
                                                                    type="text"
                                                                    id="casesOrdenL"
                                                                    name="cases"
                                                                    placeholder="Ingrese cases"
                                                                    autoComplete = "off"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* PALLETS */}

                                                            <div className='col-4 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Pallets:</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="palletsOrden"
                                                                    type="text"
                                                                    name="pallets"
                                                                    placeholder="Ingrese pallets"
                                                                    id="palletsOrdenL"
                                                                    autoComplete = "off"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                            {/* INGRESOS | EGRESOS */}

                                            <div class="accordion-item">

                                                <h2 class="accordion-header" id="headingTwo">

                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                    Ingresos | Egresos
                                                </button>

                                                </h2>

                                                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionOrdenesLogistica">

                                                    <div class="accordion-body">

                                                        <div className='row'>

                                                            {/* MONEDA */}

                                                            <div className='col-4'>

                                                                <span className="badge text-bg-secondary mb-2">Moneda:</span>

                                                                <select
                                                                    key="smonedaOrden"
                                                                    name="moneda"
                                                                    className="form-select"
                                                                    id="monedaOrdenL"
                                                                    onChange={props.onChange}>

                                                                    <option value="">Seleccione una moneda</option>
                                                                    <option value="Peso">Peso</option>
                                                                    <option value="Dolar">Dolar</option>
                                                                    
                                                                </select>

                                                            </div>

                                                            {/* TARIFA CLIENTE */}

                                                            <div className='col-4'>

                                                                <span className="badge text-bg-secondary mb-2">Tarifa Cliente:</span>

                                                                <input
                                                                    className='form-control'
                                                                    key="tarifaOrden"
                                                                    type="number"
                                                                    name="tarifa"
                                                                    id="tarifaOrdenL"
                                                                    placeholder="Ingrese tarifa"
                                                                    autoComplete = "off"
                                                                    step=".01"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* TARIFA PROVEEDOR */}

                                                            <div className='col-4'>

                                                                <span className="badge text-bg-secondary mb-2">Tarifa Proveedor:</span>

                                                                <input
                                                                    className='form-control'
                                                                    type="number"
                                                                    name="tarifa_proveedor"
                                                                    id="tarifa_proveedorL"
                                                                    placeholder="Ingrese tarifa"
                                                                    autoComplete = "off"
                                                                    step=".01"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* MONEDA */}

                                                            <div className='col-6'>

                                                                <span className="badge text-bg-secondary mb-2">Moneda Proveedor:</span>

                                                                <select
                                                                    name="tarifa_proveedor_moneda"
                                                                    className="form-select"
                                                                    id="monedaProveedorOrdenL"
                                                                    onChange={props.onChange}>

                                                                    <option value="">Seleccione una moneda</option>
                                                                    <option value="Peso">Peso</option>
                                                                    <option value="Dolar">Dolar</option>
                                                                    
                                                                </select>

                                                            </div>

                                                            {/* TIPO CAMBIO */}

                                                            <div className='col-6'>

                                                                <span className="badge text-bg-secondary mb-2">Tipo Cambio:</span>

                                                                <input
                                                                    className='form-control'
                                                                    type="number"
                                                                    name="tipo_cambio"
                                                                    id="tipo_cambioInputL"
                                                                    step="0.0001"
                                                                    placeholder="Ingrese tipo de Cambio"
                                                                    autoComplete = "off"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div>

                                                            {/* AREA PARA INGRESOS */}

                                                            <div className='col-6 mt-4'>

                                                                <div>
                                                                
                                                                    <h5 className='mb-4 text-center'>Ingresos</h5>
                                                                
                                                                    <div className='row'>
                                                        
                                                                        {/* CONCEPTO */}
                                                        
                                                                        <div className='col-5'>
                                                        
                                                                            <span className="badge text-bg-secondary mb-2">Concepto:</span>
                                                        
                                                                            <select
                                                                                name="concepto"
                                                                                className="form-select"
                                                                                onChange={(event) => {
                                                                                    setIngreso({ ...ingreso, ['concepto']: event.target.value });
                                                                                }}
                                                                                id="conceptoIngresosLogistica"
                                                                            >
                                                        
                                                                                <option value="">Seleccione Concepto</option>
                                                                                <option value="Cargo Por Retraso (Carrier)">Cargo Por Retraso (Carrier)</option>
                                                                                <option value="Cruce">Cruce</option>
                                                                                <option value="Descarga">Descarga</option>
                                                                                <option value="Demora">Demora</option>
                                                                                <option value="Estancia">Estancia</option>
                                                                                <option value="Lavado">Lavado</option>
                                                                                <option value="Movimiento En Falso">Movimiento En Falso</option>
                                                                                <option value="Millas Extras">Millas Extras</option>
                                                                                <option value="Extra Stop">Extra Stop</option>
                                                                                
                                                                                
                                                                            </select>
                                                        
                                                                        </div>
                                                        
                                                                        {/* MONTO */}
                                                        
                                                                        <div className='col-3'>
                                                        
                                                                            <span 
                                                                                className="badge text-bg-secondary mb-2"
                                                                            >
                                                                                $ Monto:
                                                                            </span>
                                                        
                                                                            <input
                                                                                className='form-control'
                                                                                type="number"
                                                                                name="monto"
                                                                                placeholder="Monto"
                                                                                step=".05"
                                                                                onChange={(event) => setIngreso({ ...ingreso, ['monto']: event.target.value })}
                                                                                id="montoIngresosLogistica"
                                                                            />
                                                        
                                                                        </div>
                                                        
                                                                        {/* MONEDA */}
                                                        
                                                                        <div className='col-3'>
                                                        
                                                                            <span className="badge text-bg-secondary mb-2">Moneda:</span>
                                                        
                                                                            <select
                                                                                name="moneda"
                                                                                className="form-select"
                                                                                onChange={(event) => setIngreso({ ...ingreso, ['moneda']: event.target.value })}
                                                                                id="monedaIngresosLogistica"
                                                                            >
                                                        
                                                                                <option value="">Moneda</option>
                                                                                <option value="MXN">MXN</option>
                                                                                <option value="USA">USA</option>
                                                                                
                                                                                
                                                                            </select>
                                                        
                                                                        </div>
                                                        
                                                                        {/* AGREGAR INGRESO */}
                                                        
                                                                        <div className='col-1 d-flex justify-content-center align-items-end'>
                                                        
                                                                            <button 
                                                                                type="button" 
                                                                                className="btn btn-primary"
                                                                                onClick={() => {
                                                                                    props.updateIngresos(ingreso);
                                                                                    setIngreso({concepto: "", monto: "", moneda: ""});
                                                                                }}
                                                                            >
                                                                                <IoIosAddCircle/>
                                                                            </button>
                                                        
                                                                        </div>
                                                        
                                                                        {/* TABLA DE INGRESOS */}
                                                        
                                                                        <div className='col-12 mt-4'>
                                                        
                                                                            <Tabla 
                                                                                columns={columnsIngresos} 
                                                                                data={props.data.ingresos ?? []} 
                                                                            />
                                                        
                                                                        </div>
                                                        
                                                                    </div>
                                                        
                                                                </div>
                                                                

                                                            </div>

                                                            {/* AREA PARA EGRESOS */}

                                                            <div className='col-6 mt-4'>

                                                                <div>
                                                                
                                                                    <h5 className='mb-4 text-center'>Egresos</h5>
                                                                
                                                                    <div className='row'>
                                                        
                                                                        {/* CONCEPTO */}
                                                        
                                                                        <div className='col-5'>
                                                        
                                                                            <span className="badge text-bg-secondary mb-2">Concepto:</span>
                                                        
                                                                            <select
                                                                                name="concepto"
                                                                                className="form-select"
                                                                                onChange={(event) => {
                                                                                    setEgreso({ ...egreso, ['concepto']: event.target.value });
                                                                                }}
                                                                                id="conceptoEgresosLogistica"
                                                                            >
                                                        
                                                                                <option value="">Seleccione Concepto</option>
                                                                                <option value="Cargo Por Retraso (Carrier)">Cargo Por Retraso (Carrier)</option>
                                                                                <option value="Cruce">Cruce</option>
                                                                                <option value="Descarga">Descarga</option>
                                                                                <option value="Demora">Demora</option>
                                                                                <option value="Estancia">Estancia</option>
                                                                                <option value="Lavado">Lavado</option>
                                                                                <option value="Movimiento En Falso">Movimiento En Falso</option>
                                                                                <option value="Millas Extras">Millas Extras</option>
                                                                                
                                                                                
                                                                            </select>
                                                        
                                                                        </div>
                                                        
                                                                        {/* MONTO */}
                                                        
                                                                        <div className='col-3'>
                                                        
                                                                            <span 
                                                                                className="badge text-bg-secondary mb-2"
                                                                            >
                                                                                $ Monto:
                                                                            </span>
                                                        
                                                                            <input
                                                                                className='form-control'
                                                                                type="number"
                                                                                name="monto"
                                                                                placeholder="Monto"
                                                                                step=".05"
                                                                                onChange={(event) => setEgreso({ ...egreso, ['monto']: event.target.value })}
                                                                                id="montoEgresosLogistica"
                                                                            />
                                                        
                                                                        </div>
                                                        
                                                                        {/* MONEDA */}
                                                        
                                                                        <div className='col-3'>
                                                        
                                                                            <span className="badge text-bg-secondary mb-2">Moneda:</span>
                                                        
                                                                            <select
                                                                                name="moneda"
                                                                                className="form-select"
                                                                                onChange={(event) => setEgreso({ ...egreso, ['moneda']: event.target.value })}
                                                                                id="monedaEgresosLogistica"
                                                                            >
                                                        
                                                                                <option value="">Moneda</option>
                                                                                <option value="MXN">MXN</option>
                                                                                <option value="USA">USA</option>
                                                                                
                                                                                
                                                                            </select>
                                                        
                                                                        </div>
                                                        
                                                                        {/* AGREGAR INGRESO */}
                                                        
                                                                        <div className='col-1 d-flex justify-content-center align-items-end'>
                                                        
                                                                            <button 
                                                                                type="button" 
                                                                                className="btn btn-primary"
                                                                                onClick={() => {
                                                                                    props.updateEgresos(egreso)
                                                                                    setEgreso({concepto: "", monto: "", moneda: ""});
                                                                                }}
                                                                            >
                                                                                <IoIosAddCircle/>
                                                                            </button>
                                                        
                                                                        </div>
                                                        
                                                                        {/* TABLA DE INGRESOS */}
                                                        
                                                                        <div className='col-12 mt-4'>
                                                        
                                                                            <Tabla 
                                                                                columns={columnsEgresos} 
                                                                                data={props.data.egresos ?? []} 
                                                                            />
                                                        
                                                                        </div>
                                                        
                                                                    </div>
                                                        
                                                                </div>
                                                                

                                                            </div>


                                                            {/* CRUCE IMPO EXPO */}

                                                            {/* <div className='col-6 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Tipo Cruce:</span>

                                                                <select
                                                                    name="cruce_impo_expo"
                                                                    className="form-select"
                                                                    id="cruce_impo_expoSelectL"
                                                                    onChange={props.onChange}>

                                                                    <option value="">Seleccione una opcion</option>
                                                                    <option value="N/A">Sin Cruce</option>
                                                                    <option value="Importacion">Importacion</option>
                                                                    <option value="Exportacion">Exportacion</option>
                                                                    
                                                                </select>

                                                            </div> */}

                                                            {/* CRUCE MONTO */}

                                                            {/* <div className='col-6 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Cruce Monto:</span>

                                                                <input
                                                                    className='form-control'
                                                                    type="number"
                                                                    name="cruce_monto"
                                                                    id="cruce_montoInputL"
                                                                    placeholder="Ingrese monto del Cruce"
                                                                    autoComplete = "off"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div> */}

                                                            {/* CRUCE ORIGEN */}
{/* 
                                                            <div className='col-6 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Cruce Origen:</span>

                                                                <input
                                                                    className='form-control'
                                                                    type="text"
                                                                    name="cruce_origen"
                                                                    id="cruce_origenInputL"
                                                                    placeholder="Ingrese Origen del Cruce"
                                                                    autoComplete = "off"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div> */}

                                                            {/* CRUCE DESTINO */}

                                                            {/* <div className='col-6 mt-4'>

                                                                <span className="badge text-bg-secondary mb-2">Cruce Destino:</span>

                                                                <input
                                                                    className='form-control'
                                                                    type="text"
                                                                    name="cruce_destino"
                                                                    id="cruce_destinoInputL"
                                                                    placeholder="Ingrese Destino del Cruce"
                                                                    autoComplete = "off"
                                                                    onChange={props.onChange}
                                                                />

                                                            </div> */}

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                            {/* ORDENES MCLEOD */}

                                            <div class="accordion-item">

                                                <h2 class="accordion-header" id="headingThree">

                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                    McLeod
                                                </button>

                                                </h2>

                                                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionOrdenesLogistica">

                                                    <div class="accordion-body">
                                                        
                                                        <div className='row'>

                                                            <div className='col-12'>

                                                                <span className="badge text-bg-secondary mb-2">Orden Mcleod:</span>

                                                                <input
                                                                    className='form-control'
                                                                    readOnly={true}
                                                                    type="text"
                                                                    name="orden_mcleod"
                                                                    placeholder="Seleccione Una Orden"
                                                                    defaultValue={props.data['orden_mcleod']}
                                                                    id="orden_mcleodL"
                                                                />

                                                            </div>

                                                            <div className='col-12 mt-3'>

                                                                <TablaMcleod handleSelect={props.onChangeMcleod}/>
                                                                
                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary"><BiSave/> Guardar</button>
                            </div>

                        </form>

                    </div>
                    
                </div>

            </div>

        </div>

    )

}

export default ModalCrearOrdenLogistica